import {createContext} from '@lit/context';
import {ProductFamilySlider} from '../../templates/components/product-family/product-family.js';

export interface ProductFamilyState {
  sliderData: ProductFamilySlider | null;
  displayType?: 'mixandmatch' | 'productline' | 'capsule';
  beauty: boolean;
  open: boolean;
  backButtonCallback?: (() => void);
  update: (newState: Partial<ProductFamilyState>) => void;
}

export const productFamilyContext = createContext<ProductFamilyState>('productFamilyContext');
